/** @type {Object <String, String>} */
const eventCodes = {
    'agentSessionEnd': 'AGENT_SESSION_END',
    'agentSessionStart': 'AGENT_SESSION_START',
    'botActive': 'BOT_ACTIVE',
    'botResponse': 'BOTRESPONSE',
    'botKitUnreachable': 'BOTKIT_UNREACHABLE',
    'chatConnected': 'CHAT_CONNECTED',
    'chatDisconnected': 'CHAT_DISCONNECTED',
    'chatTimeout': 'CHAT_TIMEOUT',
    'formSubmitted': 'FORM_SUBMITTED',
    'loginFlowStarted': 'LOGIN_FLOW_STARTED',
    'updateNewMessage': 'UPDATE_NEW_MESSAGE',
    'userClickedInput': 'USER_CLICKED_INPUT',
    'userMaskedInput': 'USER_MASKED_INPUT',
    'websocketError': 'WEBSOCKET_ERROR',
    'websocketServiceUnavailable': 'WEBSOCKET_SERVICE_UNAVAILABLE'
};

/**
 * Class to expose the custom chat event codes to allow communication
 * between child/util files and chat-bot.jsx.
 */
export default class ChatEventCodes {

    static get AgentSessionEnd() {return eventCodes.agentSessionEnd;}

    static get AgentSessionStart() {return eventCodes.agentSessionStart;}

    static get BotActive() {return eventCodes.botActive;}

    static get BotResponse() {return eventCodes.botResponse;}

    static get BotKitUnreachable() {return eventCodes.botKitUnreachable;}

    static get ChatConnected() {return eventCodes.chatConnected;}

    static get ChatDisconnected() {return eventCodes.chatDisconnected;}

    static get ChatTimeout() {return eventCodes.chatTimeout;}

    static get FormSubmitted() {return eventCodes.formSubmitted;}

    static get LoginFlowStarted() {return eventCodes.loginFlowStarted;}

    static get UpdateNewMessage() {return eventCodes.updateNewMessage;}

    static get UserClickedInput() {return eventCodes.userClickedInput;}

    static get UserMaskedInput() {return eventCodes.userMaskedInput;}

    static get WebsocketError() {return eventCodes.websocketError;}

    static get WebsocketServiceUnavailable() {return eventCodes.websocketServiceUnavailable;}
}